import React from "react";
import { Box, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const FooterComponent = () => {
  const { t } = useTranslation();

  return (
    <>
      <Box
        sx={{
          display: "flex",
          textAlign: " center",
          justifyContent: "center",
          marginTop: "20px",
        }}
        gap={2}>
        <Link to="#">
          <Typography sx={{ fontWeight: 400, fontSize: "14px" }}>
            {t('Our Location')}
          </Typography>
        </Link>
        <Link to="#">
          <Typography sx={{ fontWeight: 400, fontSize: "14px" }}>
            {t("Flight Schedule")}
          </Typography>
        </Link>
        <Link to="#">
          <Typography sx={{ fontWeight: 400, fontSize: "14px" }}>
            {t("Take a Virtual Tour")}
          </Typography>
        </Link>
        <Link to="#">
          <Typography sx={{ fontWeight: 400, fontSize: "14px" }}>
            {t('View Gallery')}
          </Typography>
        </Link>
      </Box>
      <Box
        sx={{
          display: "flex",
          textAlign: " center",
          justifyContent: "center",
          marginTop: "15px",
        }}>
        <Typography sx={{ fontWeight: 400, fontSize: "14px" }}>
          {t('Wakatobi. All rights reserved.')}
        </Typography>
      </Box>
    </>
  );
};
export default FooterComponent;
